module.exports = __webpack_public_path__ + "img/Micro_Sperm_Packaging_Diagram.0abc3deb.png";